<div
  [ngClass]="{
    'percentage-change--positive': isPositive,
    'percentage-change--negative': isNegative
  }"
  class="percentage-change">
  <span class="material-icons percentage-change__arrow">arrow_drop_up</span>
  <span
    [ngClass]="{'percentage-change__value--non-zero': isNegative || isPositive}"
    class="percentage-change__value"
    data-cy="percentage-change.value"
  >{{ value === undefined || value === null ? 'n/a' : ((value | absoluteValue) + '%') }}</span>
</div>
